import React, { useEffect } from 'react'
import { Box, Paper, Typography } from '@mui/material'
import HeaderBlockProperties from './blocks-properties/HeaderBlockProperties'
import ImageBlockProperties from './blocks-properties/ImageBlockProperties'
import TextBlockProperties from './blocks-properties/TextBlockProperties'
import ButtonBlockProperties from './blocks-properties/ButtonBlockProperties'
import DividerBlockProperties from './blocks-properties/DividerBlockProperties'
import SpacerBlockProperties from './blocks-properties/SpacerBlockProperties'
import ContainerBlockProperties from './blocks-properties/ContainerBlockProperties'
import ListItemsBlockProperties from './blocks-properties/ListItemsBlockProperties'
import { Tabs, Tab } from '@mui/material'
import GlobalProperties from './blocks-properties/GlobalProperties'
import useEmailEditorStore from '../utilities/emailEditorStore'
import { BLOCK_TYPES } from '../utilities/blockTypes'
import ColumnBlockProperties from './blocks-properties/ColumnBlockProperties'
import ColumnContainerBlockProperties from './blocks-properties/ColumnContainerBlockProperties'
import HtmlBlockProperties from './blocks-properties/HtmlBlockProperties'

const TabPanel = ({ children, value, index }) => {
  return (
    <div 
      role="tabpanel" 
      hidden={value !== index} 
      id={`simple-tabpanel-${index}`} 
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function PropertiesPanel() {
  const [value, setValue] = React.useState(0)
  
  // Get data and actions from the store
  const { 
    selectedBlockId, 
    getSelectedBlock, 
    globalProperties, 
    updateGlobalProperties 
  } = useEmailEditorStore()
  
  // Get the currently selected block
  const selectedBlock = getSelectedBlock()

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleGlobalPropertyChange = (property, value) => {
    updateGlobalProperties({ [property]: value })
  }

  useEffect(() => {
    if (!selectedBlock) {
      setValue(0) // Switch to Global tab when no block is selected
    } else {
      setValue(1) // Switch to Selected Block tab when a block is selected
    }
  }, [selectedBlock])

  const renderProperties = () => {
    if (!selectedBlock) return (
      <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
        <Typography variant="body2">
          No block selected. Select a block to edit its properties.
        </Typography>
      </Box>
    )

    switch (selectedBlock.type) {
      case BLOCK_TYPES.HEADER:
        return (
          <HeaderBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.IMAGE:
        return (
          <ImageBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.TEXT:
        return (
          <TextBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.LISTITEMS:
        return (
          <ListItemsBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.BUTTON:
        return (
          <ButtonBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.DIVIDER:
        return (
          <DividerBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.SPACER:
        return (
          <SpacerBlockProperties 
           blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.CONTAINER:
        return (
          <ContainerBlockProperties 
            blockId={selectedBlockId}
          />
        )
       case BLOCK_TYPES.COLUMNCONTAINER:
        return (
          <ColumnContainerBlockProperties
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.COLUMN:
        return (
           <ColumnBlockProperties 
            blockId={selectedBlockId}
          />
        )
      case BLOCK_TYPES.HTMLCONTENT:
        // You might need to create an HTMLContentBlockProperties component
        return (
          <HtmlBlockProperties
            blockId={selectedBlockId}
          />
        )
      default:
        return (
          <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
            <Typography variant="body2">
              Properties for {selectedBlock.type} block type not implemented yet.
            </Typography>
          </Box>
        )
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 0 }}>
      <Paper sx={{ p: 1, mb: 2, minHeight: '90vh', overflow: 'visible' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleTabChange} aria-label="properties tabs">
            <Tab label="Global" id="simple-tab-0" aria-controls="simple-tabpanel-0" />
            <Tab 
              label={selectedBlock ? `${selectedBlock.type} Block` : "Selected Block"} 
              id="simple-tab-1" 
              aria-controls="simple-tabpanel-1"
              disabled={!selectedBlock}
            />
          </Tabs>
        </Box>
        
        <TabPanel value={value} index={0}>
          <GlobalProperties 
            globalProperties={globalProperties}
            handleGlobalPropertyChange={handleGlobalPropertyChange}
          />
        </TabPanel>
        
        <TabPanel value={value} index={1}>
          {renderProperties()}
        </TabPanel>
      </Paper>
    </Box>
  )
}

export default PropertiesPanel